import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface StatusStep {
  title: string;
  subtitle?: string;
}

@Component({
  standalone: true,
  selector: 'app-status-stepper',
  templateUrl: './status-stepper.component.html',
  styleUrls: ['./status-stepper.component.scss'],
  imports: [CommonModule, MatIconModule]
})
export class StatusStepperComponent {
  @Input() steps!: StatusStep[];
  @Input() currentStep!: number;
}
